import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';

export const namespace = 'account';
const actionCreator = actionCreatorFactory(namespace);
export const DeleteAccount = actionCreator<{}>('DELETE_ACCOUNT');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {}

const initialState = (): State => {
  return {};
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(DeleteAccount, async function(_context, action) {
      await this.proffApi.deleteAccount(action.payload);
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
};
